import React from 'react';
import { cn } from '../../lib/utils';

const Logo = ({ className, iconOnly = false, light = false }) => {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <div className={cn(
        "relative flex-shrink-0 flex items-center justify-center rounded-full overflow-hidden",
        light ? "bg-white/10 p-1" : ""
      )}>
        <img 
          src="https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvcG5n/c4274d98d42da48f19f125f5c5e6c673.png" 
          alt="AGIR USA Logo" 
          className={cn(
            "w-12 h-12 object-contain", 
            !light && "mix-blend-multiply" // Ensures white background is transparent on light surfaces
          )}
          width="48"
          height="48"
          loading="eager"
        />
      </div>
      {!iconOnly && (
        <div className="flex flex-col leading-none">
          <span className={cn(
            "font-heading font-bold text-xl tracking-tight",
            light ? "text-white" : "text-primary-dark"
          )}>
            AGIR <span className="text-secondary">USA</span>
          </span>
          <span className={cn(
            "text-[8px] font-bold tracking-[0.2em] uppercase mt-1",
            light ? "text-white/60" : "text-gray-400"
          )}>
            Guinea-Bissau
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;